import { InputSelect } from "@UI/InputNew";
import { useMemo } from 'react';
import s from './index.module.css';
import classNames from "classnames";

const Number = ({changeRegularity, index, number, firstField}) => {
    const optionsNumber = useMemo(()=>{
        const option = [];
        for(let i=1; i < 32; i++){
            option.push(
                {
                    label: `${i}`,
                    value: i
                }
            )
        }
        return option;
    }, [])

    return (
        <>
            <InputSelect
                options={optionsNumber}
                newDesign
                value={number}
                onChange={
                    (e) => {
                        changeRegularity(index, e.target.value, firstField, 'number')
                    }
                }
                className={s.select} 
                classNameBox={classNames(s.selectBox, s.selectBoxNumber)}
                hideIcon={true}
            />
        </>
    )
}

export default Number;